import React from 'react';
import PropTypes from 'prop-types';
import css from './Error.css';
import Icon from 'SF/MaterialIcon';

const ErrorSpan = ({error}) => {
  if ( !error ) return null;
  return (
    <span className={css['errorMessage']}>
      <Icon aria-hidden="true" icon="error" />
      {error}
    </span>
  );
};

ErrorSpan.propTypes = {
  error: PropTypes.string.isRequired,
};

export default ErrorSpan;
